/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const WebAppAudioQualityIssueDtoKindEnum = {
    silent: "silent",
    poor_quality: "poor_quality"
} as const;

export type WebAppAudioQualityIssueDtoKindEnumKey = (typeof WebAppAudioQualityIssueDtoKindEnum)[keyof typeof WebAppAudioQualityIssueDtoKindEnum];

export type WebAppAudioQualityIssueDto = {
    /**
     * @description Station the issue belongs to.
     * @type string
    */
    stationId: string;
    /**
     * @description Type of issue: `silent` when no audio was detected, `poor_quality` when audio was present but degraded.
     * @type string
    */
    kind: WebAppAudioQualityIssueDtoKindEnumKey;
    /**
     * @description Start of the affected period (UTC ISO-8601).
     * @type string
    */
    start: string;
    /**
     * @description End of the affected period (UTC ISO-8601).
     * @type string
    */
    end: string;
    /**
     * @description Seconds actually affected inside the period. It can be shorter than the difference between `start` and `end`, because only the degraded audio is counted.
     * @type number
    */
    durationSeconds: number;
    /**
     * @description Average share of the period detected as silence, from 0 to 1. Only reported for `silent` issues, otherwise null.
     * @minLength 0
     * @maxLength 1
     * @type number
    */
    avgSilenceRatio: number | null;
    /**
     * @description Average audio quality score during the period, from 0 (worst) to 1 (best). Only reported for `poor_quality` issues, otherwise null.
     * @minLength 0
     * @maxLength 1
     * @type number
    */
    avgQualityScore: number | null;
};